import { User } from "@radarly/models/user";
import { RadarlyAPI } from "./base";

export class MemberAPI extends RadarlyAPI {
  public async getMember(id: number) {
    return id ? await this.get<User>(`/users/${id}.json`) : null;
  }
}
